import { X } from "lucide-react";

import { QueryParams, useURLParamsData } from "@/shared/hooks/useURLParamsData";
import { localizationMap } from "@/shared/lib/consts";
import { Button } from "@/shared/ui/button";

const FILTER_LABELS: Record<string, string> = {
  search: "Поиск",
  sort: "Сортировка",
  order: "Порядок",
  status: "Статус",
  leadStatus: "Статус",
  linkStatus: "Статус",
  managerStatus: "Статус",
  payoutStatus: "Статус",
  type: "Тип",
  candidateStatus: "Статус",
  leadRequestStatus: "Статус",
};

const REQUIRED_LABELS = ["filter", "length"];

export const ActiveFilters = ({ refetch }: { refetch: () => void }) => {
  const {
    sort,
    order,
    status,
    leadStatus,
    linkStatus,
    managerStatus,
    payoutStatus,
    type,
    setOrder,
    resetUrlParams,
  } = useURLParamsData();

  const filters = [
    { key: "sort", value: sort },
    { key: "status", value: status },
    { key: "leadStatus", value: leadStatus },
    { key: "linkStatus", value: linkStatus },
    { key: "managerStatus", value: managerStatus },
    { key: "payoutStatus", value: payoutStatus },
    { key: "type", value: type },
  ].filter(
    ({ key, value }) =>
      !REQUIRED_LABELS.includes(key) &&
      value !== undefined &&
      value !== "" &&
      value !== null,
  );

  if (filters.length === 0) return null;

  return (
    <div className="flex flex-wrap gap-2 md:absolute md:-top-8">
      {filters.map(({ key, value }) => (
        <div
          key={key}
          className="flex items-center gap-1 rounded-full bg-muted px-3 py-1 text-sm dark:bg-strokeColor"
        >
          <span className="text-textColor">
            {FILTER_LABELS[key] || key}:{" "}
            {value && (localizationMap[value] || value)}
            {key === QueryParams.SORT && (
              <>
                {" "}
                -{" "}
                {order && <i className="lowercase">{localizationMap[order]}</i>}
              </>
            )}
          </span>
          <Button
            size="icon"
            variant="ghost"
            className="h-5 w-5 p-0"
            onClick={() => {
              resetUrlParams([key as QueryParams]);
              if (key === QueryParams.SORT) {
                setOrder(null);
              }
              refetch();
            }}
          >
            <X size={13} />
          </Button>
        </div>
      ))}
    </div>
  );
};
